
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30211',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30211",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54449",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7980",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11427",
  "I18n": "static-7.1614",
  "quartz": "static-1.6973",
  "quartz-config": "static-1.751",
  "quartz-core": "static-1.6192",
  "react-dlb": "static-1.78",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.782",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54436",
  "feedback-utils": "static-1.54440",
  "forms-embed-utils-lib": "static-1.4427",
  "forms-utils-lib": "static-1.12506",
  "foundations-assets": "static-1.4823",
  "foundations-components": "static-1.7856",
  "foundations-theming": "static-1.4382",
  "hub-http": "static-1.6187",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11735",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3886",
  "raven": "static-3.5829",
  "react": "static-7.185",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16634",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5314",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.486",
  "tinymce-plugins": "static-1.57373",
  "transmute": "static-2.85",
  "ui-images": "static-2.1143",
  "UIComponents": "static-3.8374",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3374",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3250",
  "quartz-webpack": "static-1.3197",
  "foundations-theming-specialty": "static-1.2098",
  "property-description-translator": "static-1.3811",
  "HeadJS": "static-2.742",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3091",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4289",
  "jasmine-runner": "static-1.6433",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4622",
  "mobile-manifest-mixins": "static-1.516",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.648",
  "quartz-head": "static-1.638",
  "quartz-i18n": "static-1.648",
  "quartz-routing": "static-1.403",
  "quartz-test": "static-1.648",
  "quartz-tracking": "static-1.352",
  "ui-fonts": "static-1.689",
  "usage-tracker-container": "static-1.7293",
  "usage-tracker-core": "static-1.7153",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7214",
  "reference-resolvers": "static-1.8135",
  "sanitize-text": "static-1.8108",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10336",
  "sanitize": "static-1.4437",
  "outpost": "static-1.4151",
  "rpc-client-utils": "static-1.4616",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4125",
  "floating-ui": "static-1.55",
  "hs-story-utils": "static-1.9394",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1743",
  "bend-plugin-foundations-theming": "static-1.2865",
  "foundations-theming-base": "static-1.3367",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.54",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "ai-components-ui-library": "static-1.8841",
  "atom": "static-1.5037",
  "codemirror": "static-5.94",
  "content-assistance-lib": "static-1.7692",
  "ContentUtils": "static-1.68251",
  "data-token-picker": "static-1.16338",
  "file-manager-components": "static-1.23512",
  "FileManagerCore": "static-1.39011",
  "FileManagerLib": "static-1.39152",
  "frontend-preferences-client": "static-1.7894",
  "hub-http-contrib": "static-1.3005",
  "interframe": "static-3.4726",
  "layout-dnd-components": "static-1.12369",
  "layout-dnd-utils": "static-1.11344",
  "property-translator": "static-1.5366",
  "react-codemirror": "static-1.10589",
  "react-colorpicker": "static-2.10176",
  "reference-resolvers-lite": "static-1.8060",
  "rich-text-lib": "static-1.19764",
  "tinymce-data": "static-1.40344",
  "tinymce-themes": "static-1.56229",
  "ui-addon-emoji-picker": "static-1.9853",
  "ui-addon-sales-email": "static-1.5176",
  "ui-brand-identity-lib": "static-1.15105",
  "bender-build-tools": "static-1.3151",
  "hub-http-shared-msw-handlers": "static-1.9870",
  "hubspotter-http-shared-msw-handlers": "static-1.9868",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4989",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.26",
  "chirp-fetch": "static-1.1850",
  "chatspot-core": "static-1.21112",
  "copilot-toolkit": "static-1.11033",
  "customer-data-objects-ui-components": "static-1.12991",
  "data-fetching-client": "static-1.9638",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4731",
  "ui-addon-video-player": "static-1.8663",
  "ui-coaching-tips": "static-1.28441",
  "usage-tracker": "static-1.7303",
  "cms-field-types": "static-1.4777",
  "content-icons-ui": "static-1.2216",
  "integrations-lib": "static-1.15997",
  "customer-data-objects": "static-1.7628",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4613",
  "apollo-stack-hubspot": "static-3.85",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "immerable": "static-1.4118",
  "ui-addon-iframeable": "static-1.9023",
  "video-components-external": "static-1.11146",
  "video-data-lib": "static-1.34804",
  "audio-components": "static-1.5857",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29225",
  "FileManagerImages": "static-1.36663",
  "foundations-components-legacy": "static-1.881",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.524",
  "ui-universal-auth": "static-1.8929",
  "urlinator": "static-1.4496",
  "video-components": "static-1.13149",
  "video-embed": "static-1.35638",
  "ts-schema": "static-1.4048",
  "ContentData": "static-1.68326",
  "layout-data-lib": "static-1.9669",
  "react-dnd-compat": "static-1.4585",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1510",
  "external-options-client-types": "static-1.4128",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6845",
  "hs-promise-utils": "static-1.5558",
  "inbound-db-properties-service-client": "static-1.3810",
  "NamespacedHubStyle": "static-2.9032",
  "growth-onboarding-confetti": "static-1.3032",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11115",
  "amplitude-session-replay-browser": "static-1.59",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5536",
  "magpie-types": "static-1.4996",
  "simple-logging-lib": "static-1.3014",
  "avatar-components": "static-1.2464",
  "customer-data-ui-utilities": "static-1.9792",
  "growth-onboarding-feedback-components": "static-1.6548",
  "flux-actions": "static-1.331",
  "hubspot-apollo-client": "static-1.4841",
  "integrations-error-boundary-lib": "static-1.13412",
  "integrations-tracking-lib": "static-1.5564",
  "laboratory-lib": "static-3.7124",
  "native-integrations-shared-strings": "static-1.7748",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10114",
  "unified-auth": "static-1.443",
  "navigation-messaging": "static-1.7231",
  "content-media-composition-data-lib": "static-1.12131",
  "content-media-compositions": "static-2.16138",
  "idb-keyval": "static-1.43",
  "media-bridge-lib": "static-1.18860",
  "unified-auth-core-lib": "static-1.724",
  "social-insights-client-types": "static-1.21989",
  "advanced-menus-core": "static-1.15067",
  "advanced-menus-lib": "static-1.12016",
  "ExportDialog": "static-6.10359",
  "ui-memberships-settings-lib": "static-1.33941",
  "conditional-properties-service-client": "static-1.3767",
  "crm-pipelines-api-client-types": "static-1.4112",
  "framework-builder-read-service-client": "static-1.3979",
  "framework-data-schema-quick-fetch": "static-1.6750",
  "inbound-db-meta-service-client": "static-1.3560",
  "multi-currency-client-types": "static-1.3661",
  "persist-promise": "static-1.3667",
  "foundations-components-test-utils": "static-1.5339",
  "reactive-lib": "static-1.686",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.300",
  "universal-page-editor-lib": "static-1.2978",
  "google-sheets-integration-lib": "static-1.126",
  "microsoft-drive-integration-lib": "static-1.243",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3697",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15066",
  "simple-menus-lib": "static-1.16583",
  "crm-record-cards-service-types": "static-1.3578",
  "location-customization-utils-lib": "static-1.9141",
  "react-flip-move": "static-1.69"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30211",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54449",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7980",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11427",
  "I18n": "/I18n/static-7.1614",
  "quartz": "/quartz/static-1.6973",
  "quartz-config": "/quartz-config/static-1.751",
  "quartz-core": "/quartz-core/static-1.6192",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.782",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54436",
  "feedback-utils": "/feedback-utils/static-1.54440",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4427",
  "forms-utils-lib": "/forms-utils-lib/static-1.12506",
  "foundations-assets": "/foundations-assets/static-1.4823",
  "foundations-components": "/foundations-components/static-1.7856",
  "foundations-theming": "/foundations-theming/static-1.4382",
  "hub-http": "/hub-http/static-1.6187",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11735",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3886",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.185",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16634",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5314",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tinymce-plugins": "/tinymce-plugins/static-1.57373",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1143",
  "UIComponents": "/UIComponents/static-3.8374",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3374",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3250",
  "quartz-webpack": "/quartz-webpack/static-1.3197",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2098",
  "property-description-translator": "/property-description-translator/static-1.3811",
  "HeadJS": "/HeadJS/static-2.742",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3091",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4289",
  "jasmine-runner": "/jasmine-runner/static-1.6433",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4622",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.516",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.648",
  "quartz-head": "/quartz-head/static-1.638",
  "quartz-i18n": "/quartz-i18n/static-1.648",
  "quartz-routing": "/quartz-routing/static-1.403",
  "quartz-test": "/quartz-test/static-1.648",
  "quartz-tracking": "/quartz-tracking/static-1.352",
  "ui-fonts": "/ui-fonts/static-1.689",
  "usage-tracker-container": "/usage-tracker-container/static-1.7293",
  "usage-tracker-core": "/usage-tracker-core/static-1.7153",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7214",
  "reference-resolvers": "/reference-resolvers/static-1.8135",
  "sanitize-text": "/sanitize-text/static-1.8108",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10336",
  "sanitize": "/sanitize/static-1.4437",
  "outpost": "/outpost/static-1.4151",
  "rpc-client-utils": "/rpc-client-utils/static-1.4616",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4125",
  "floating-ui": "/floating-ui/static-1.55",
  "hs-story-utils": "/hs-story-utils/static-1.9394",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1743",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2865",
  "foundations-theming-base": "/foundations-theming-base/static-1.3367",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.54",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8841",
  "atom": "/atom/static-1.5037",
  "codemirror": "/codemirror/static-5.94",
  "content-assistance-lib": "/content-assistance-lib/static-1.7692",
  "ContentUtils": "/ContentUtils/static-1.68251",
  "data-token-picker": "/data-token-picker/static-1.16338",
  "file-manager-components": "/file-manager-components/static-1.23512",
  "FileManagerCore": "/FileManagerCore/static-1.39011",
  "FileManagerLib": "/FileManagerLib/static-1.39152",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7894",
  "hub-http-contrib": "/hub-http-contrib/static-1.3005",
  "interframe": "/interframe/static-3.4726",
  "layout-dnd-components": "/layout-dnd-components/static-1.12369",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11344",
  "property-translator": "/property-translator/static-1.5366",
  "react-codemirror": "/react-codemirror/static-1.10589",
  "react-colorpicker": "/react-colorpicker/static-2.10176",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8060",
  "rich-text-lib": "/rich-text-lib/static-1.19764",
  "tinymce-data": "/tinymce-data/static-1.40344",
  "tinymce-themes": "/tinymce-themes/static-1.56229",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9853",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5176",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15105",
  "bender-build-tools": "/bender-build-tools/static-1.3151",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9870",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9868",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4989",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.26",
  "chirp-fetch": "/chirp-fetch/static-1.1850",
  "chatspot-core": "/chatspot-core/static-1.21112",
  "copilot-toolkit": "/copilot-toolkit/static-1.11033",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12991",
  "data-fetching-client": "/data-fetching-client/static-1.9638",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4731",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8663",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28441",
  "usage-tracker": "/usage-tracker/static-1.7303",
  "cms-field-types": "/cms-field-types/static-1.4777",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "integrations-lib": "/integrations-lib/static-1.15997",
  "customer-data-objects": "/customer-data-objects/static-1.7628",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4613",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4118",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9023",
  "video-components-external": "/video-components-external/static-1.11146",
  "video-data-lib": "/video-data-lib/static-1.34804",
  "audio-components": "/audio-components/static-1.5857",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29225",
  "FileManagerImages": "/FileManagerImages/static-1.36663",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.881",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.524",
  "ui-universal-auth": "/ui-universal-auth/static-1.8929",
  "urlinator": "/urlinator/static-1.4496",
  "video-components": "/video-components/static-1.13149",
  "video-embed": "/video-embed/static-1.35638",
  "ts-schema": "/ts-schema/static-1.4048",
  "ContentData": "/ContentData/static-1.68326",
  "layout-data-lib": "/layout-data-lib/static-1.9669",
  "react-dnd-compat": "/react-dnd-compat/static-1.4585",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1510",
  "external-options-client-types": "/external-options-client-types/static-1.4128",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6845",
  "hs-promise-utils": "/hs-promise-utils/static-1.5558",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3810",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9032",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3032",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11115",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5536",
  "magpie-types": "/magpie-types/static-1.4996",
  "simple-logging-lib": "/simple-logging-lib/static-1.3014",
  "avatar-components": "/avatar-components/static-1.2464",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9792",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6548",
  "flux-actions": "/flux-actions/static-1.331",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4841",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13412",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5564",
  "laboratory-lib": "/laboratory-lib/static-3.7124",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7748",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10114",
  "unified-auth": "/unified-auth/static-1.443",
  "navigation-messaging": "/navigation-messaging/static-1.7231",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12131",
  "content-media-compositions": "/content-media-compositions/static-2.16138",
  "idb-keyval": "/idb-keyval/static-1.43",
  "media-bridge-lib": "/media-bridge-lib/static-1.18860",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.724",
  "social-insights-client-types": "/social-insights-client-types/static-1.21989",
  "advanced-menus-core": "/advanced-menus-core/static-1.15067",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12016",
  "ExportDialog": "/ExportDialog/static-6.10359",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33941",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3767",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4112",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3979",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6750",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3560",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3661",
  "persist-promise": "/persist-promise/static-1.3667",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5339",
  "reactive-lib": "/reactive-lib/static-1.686",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.300",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2978",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.126",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.243",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3697",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15066",
  "simple-menus-lib": "/simple-menus-lib/static-1.16583",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3578",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9141",
  "react-flip-move": "/react-flip-move/static-1.69"
}
};
